import { citaYaEmpezo } from './horaMadrid';

/**
 * Las tres formas de cancelar una cita abierta (3/11, B1), para el modal compartido por el panel del
 * técnico y el resumen. Pura, para poder probarla sin DOM.
 *
 * «No asistió» sólo si la hora de la cita ya llegó (hora de Madrid): el servidor dice lo mismo
 * (400 fecha_futura), pero aquí se ve antes de intentarlo.
 */
export const MOTIVO_CANCELAR_MAX = 500;

export function opcionesCancelacion(cita, ahora = new Date()) {
  const yaEmpezo = citaYaEmpezo(cita, ahora);
  return [
    {
      tipo: 'usuario',
      label: 'Cancelada por el usuario',
      descripcion: 'La persona no puede venir. Le cuenta como una cancelación suya, pero no sale de la campaña: vuelve a «sin cita» y se le avisa para que reserve otra.',
      disponible: true,
    },
    {
      tipo: 'sistemas',
      label: 'Cancelada por sistemas',
      descripcion: 'La cancelamos nosotros. No le cuenta como cancelación; vuelve a «sin cita» y se le avisa para que reserve otra.',
      disponible: true,
    },
    {
      tipo: 'no_asistio',
      label: 'No asistió',
      descripcion: 'La cita ya pasó y la persona no vino. Le cuenta como una cancelación; vuelve a «sin cita».',
      disponible: yaEmpezo,
      porque: yaEmpezo ? null : 'Sólo cuando ya haya llegado la hora de la cita.',
    },
  ];
}
